import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaDiariasPassagens: ['exercicio'],
    removeAdministracaoConsultaDiariasPassagens: ['administracao'],
    removeNomeConsultaDiariasPassagens: ['nome'],
    removeCpfConsultaDiariasPassagens: ['cpf'],
    removeDataEmpenhoInicialConsultaDiariasPassagens: ['dataEmpenhoInicial'],
    removeDataEmpenhoFinalConsultaDiariasPassagens: ['dataEmpenhoFinal'],
    removeCargoConsultaDiariasPassagens: ['cargo'],
    setMostraAplicarFiltroConsultaDiariasPassagens: [],
    limpaFiltroConsultaDiariasPassagens: [],
    aplicarFiltroConsultaDiariasPassagens: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: [],
    nome: '',
    cpf: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    cargo: [],
    mostraAplicarFiltro: false,
    status: '',
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: '', mostraAplicarFiltro: true }
}

const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}

const removeDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: '', mostraAplicarFiltro: true }
}

const removeDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: '', mostraAplicarFiltro: true }
}

const removeCargo = (state = INITIAL_STATE, action) => {
    state.cargo.splice(state.cargo.indexOf(action.cargo), 1)

    state.cargo = Array.from(state.cargo)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_DIARIAS_PASSAGENS]: removeExercicio,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_DIARIAS_PASSAGENS]: removeAdministracao,
    [Types.REMOVE_NOME_CONSULTA_DIARIAS_PASSAGENS]: removeNome,
    [Types.REMOVE_CPF_CONSULTA_DIARIAS_PASSAGENS]: removeCpf,
    [Types.REMOVE_DATA_EMPENHO_INICIAL_CONSULTA_DIARIAS_PASSAGENS]: removeDataEmpenhoInicial,
    [Types.REMOVE_DATA_EMPENHO_FINAL_CONSULTA_DIARIAS_PASSAGENS]: removeDataEmpenhoFinal,
    [Types.REMOVE_CARGO_CONSULTA_DIARIAS_PASSAGENS]: removeCargo,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_DIARIAS_PASSAGENS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_DIARIAS_PASSAGENS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_DIARIAS_PASSAGENS]: aplicarFiltro,
})
